import { getAudioCapabilities, getVideoCapabilities } from '@mi-front/core';
import { usePostHog } from 'posthog-js/react';
import { useEffect } from 'react';

/**
 * Syncs media tech capabilities (audio/video) to PostHog as person properties
 * so they are available for segmentation without emitting events.
 */
export function usePostHogMediaTechSync() {
  const posthog = usePostHog();

  useEffect(() => {
    if (!posthog) return;

    try {
      posthog.people.set({
        media_tech_audio: getAudioCapabilities(),
        media_tech_video: getVideoCapabilities(),
      });
    } catch {
      // ignore analytics failures
    }
  }, [posthog]);
}
